import React, { Component } from "react";
import { Route } from "react-router-dom";
import About from "./Containers/About";
import Experiences from "./Containers/Experiences/Experiences";
import Projects from "./Containers/Projects/Projects";
import External from "./Containers/External";
import Contact from "./Containers/Contact";
import Base from "./Containers/Base";
import Nav from "./Containers/Nav";

class App extends Component {
  state = {
    experience: [
      {
        name: "Flexiele",
        position: "MEAN Stack Developer",
        desc:
          "Implemented authentication and security of the website 🔐 through various encryption services🛡️. Created a submodule for Employee termination and reverse termination and Created various API endpoints for the user.",
        date: "Jan 2020 - April 2020",
        key: 1,
      },
      {
        name: "UpGrad",
        position: "Teaching Assitant(Full Stack)",
        desc:
          "Taught Web Development/Design to 3rd-year Computer Science students 👨‍🏫👨‍🏫. Was Responsible for lectures on javascript, solving doubts/queries😕 of students. Helped Students with guiding them through the assignments and tests📘.",
        date: "Sep 2019 - Nov 2019",
        key: 2,
      },
      {
        name: "Auctus Advisors",
        position: "Software Developer Intern",
        desc:
          "Worked on completely remaking of the dashboard systems (one of the products of Auctus Advisors) for various MNC and Malls🏨🏢 with the latest technologies and tools. Improved the efficiency of the product gradually, with a significant improvement in design, flexibility, and security of the product🔐.",
        date: "Apr 2019 - June 2019",
        key: 3,
      },
      {
        name: "Social App",
        position: "Backend Developer",
        desc:
          "Acted as a Full-Stack Web Developer for the startup. Build authentication / registration system from scratch. 💻Worked on Technologies like React JS, Node JS ,MySQL🗃️ etc",
        date: "Dec 2018 - May 2019",
        key: 4,
      },
    ],
    backColor: "#9BAB9A",
    loaded: false,
  };

  changeBagColor = (color) => {
    this.setState({ backColor: color });
  };

  // showLoader = () => {
  //   setTimeout(() => {
  //     this.setState({ loaded: true });
  //   }, 2000);
  //   return (
  //     <div class="ui segment" style={{ height: "100vh", width: "100vw", margin: "0px",outlineColor:'black' }}
  //     >
  //     <div class="ui active dimmer">
  //       <div class="ui massive text loader">Loading</div>
  //     </div>
  //     <p></p>
  //     <p></p>
  //     <p></p>
  //   </div>
  //   );
  // };

  render() {
    return( 
    // this.state.loaded === false ? (
    //   this.showLoader()
    // ) : 
      <div
        className="ui stackable grid items segment"
        style={{ minHeight: "100vh", backgroundColor: this.state.backColor }}
      >
        <Base />
        <div className="ten wide column">
          <Nav />
          <div>
            <Route
              path="/"
              exact
              render={() => (
                <About
                  color={this.state.backColor}
                  backColor={this.changeBagColor}
                />
              )}
            />
            <Route
              path="/experiences"
              render={() => (
                <Experiences
                  color={this.state.backColor}
                  backColor={this.changeBagColor}
                  experiences={this.state.experience}
                />
              )}
            />
            <Route
              path="/projects"
              render={() => (
                <Projects
                  color={this.state.backColor}
                  backColor={this.changeBagColor}
                />
              )}
            />
            <Route
              path="/external"
              render={() => (
                <External
                  color={this.state.backColor}
                  backColor={this.changeBagColor}
                />
              )}
            />
            <Route
              path="/contact"
              render={() => (
                <Contact
                  color={this.state.backColor}
                  backColor={this.changeBagColor}
                />
              )}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default App;
